export default __webpack_public_path__ + "static/media/IMG-activityPH_sensory.3e9c5b30.png";